import NotificationCenter from "../../../components/NotificationCenter";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, actions, backTo, showNotifications = true }) => {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between p-4 bg-white/80 backdrop-blur-sm border-b border-slate-200">
      <div className="flex items-center gap-3">
        {backTo && (
          <button onClick={() => navigate(backTo)} className="-ml-2 p-2 hover:bg-slate-100 rounded-full">
            <ArrowLeft size={20} className="text-slate-600" />
          </button>
        )}
        <h1 className="text-lg font-bold text-slate-800">{title}</h1>
      </div>
      <div className="flex items-center space-x-2">
        {actions}
        {showNotifications && <NotificationCenter />}
      </div>
    </div>
  );
};

export default PageHeader;
